import { memo, useContext, useEffect, useState } from 'react'
import AppBar from '@mui/material/AppBar'
import { Box, Toolbar, IconButton, Button, Tooltip, Menu, MenuItem, Popover, Typography, Divider } from '@mui/material'
import { Menu as MenuIcon, Home, Wifi, HeadsetMic, PowerSettingsNew, KeyboardArrowDown, KeyboardArrowUp, ReceiptLong, Build, Download } from '@mui/icons-material'
import { useAppTheme } from '../../Providers/ThemeContext/ThemeContext'
import Logo from '../../Assets/Logo/one_branco_1.png'

import { BarHeight, BoxDireita, BoxEsquerda, BoxName, IconBtn } from './sxNavBar'
import { WebSocketContext } from '../../Providers/WebSocket/WebSocketContext'
import { UserContext } from '../../Providers/UserContext/UserContex'

import { useLocation, useNavigate } from 'react-router-dom'
import { FormJornada, JornadaButton } from '../FormJornada/FormJornada'
import OneModal from '../OneModal/OneModal'
import OneContador from '../FormJornada/OneContador/OneContador'
import ConfirmModal from '../ConfirmModal/ConfirmModal'
import AvatarOne from '../AvatarOne/AvatarOne'
import VideoApresentacao from '../VideoApresentacao/VideoApresentacao'
import { LogadoContext } from '../../Providers/LogadoContext/LogadoContext'
import { ChangeComponentContext } from '../../Providers/ChangeComponentContext/ChangeComponentContext'
import { OrdemServicoContext } from '../../Providers/OrdemServicoContext/OrdemServicoContext'
import { CondominiosContext } from '../../Providers/CondominiosContext/CondominiosContext'
import { EventosContext } from '../../Providers/EventosContext/EventosContext'
import ModalFecharEventos from '../ModalFecharEventos/ModalFecharEventos.jsx'
import InfoCondIcone from "../../Assets/icones/info-condominio.svg"
import NewLabel from '../NewLabel/NewLabel.jsx'

const NavBar = () => {
    const { theme } = useAppTheme()

    const Navigate = useNavigate()

    const { wsConectado } = useContext(WebSocketContext)
    const { user, logout } = useContext(UserContext)
    const { logado } = useContext(LogadoContext)
    const { changeShowComponent } = useContext(ChangeComponentContext)
    const { buscarOrdensServico } = useContext(OrdemServicoContext)
    const { rmActiveCond } = useContext(CondominiosContext)
    const { removerEventoSelecionado } = useContext(EventosContext)

    const [openJornada, setOpenJornada] = useState(false)

    const [openFecharEventos, setOpenFecharEventos] = useState(false)

    const [anchorMenu, setAnchorMenu] = useState(false)

    const [userMenu, setUserMenu] = useState(false)

    const openMenu = Boolean(anchorMenu)

    const openUserMenu = Boolean(userMenu)

    const active_page = useLocation().pathname

    const { addRoute, sendWs } = useContext(WebSocketContext)

    const handleFecharEventosEmMassa = () => {
        rmActiveCond(true)
        removerEventoSelecionado()
        setOpenFecharEventos(true)
    }

    const menu_items = [
        {
            label: 'Monitoramento',
            navigate: '/'
        },
        {
            label: 'Configurações',
            navigate: '/configuracoes'
        },
        {
            label: 'Gestão de Eventos',
            navigate: '/gestaoEventos'
        },
        {
            label: 'ONE Acessos',
            link: `${window.location.origin.replace(':3003', '')}/wsOnePortaria/oneacessos/login.php`
        },
        {
            label: 'BI ONE Dash',
            link: `${window.location.origin.replace(':3003', '')}/BI/login.php`
        },
        {
            label: 'Quem Está Dentro',
            link: `${window.location.origin.replace(':3003', '')}/wsOnePortaria/quemEstaDentro/login.php`
        },
        {
            label: 'Área do Cliente',
            link: 'https://adm.oneportaria.com.br/areacliente/login'
        },
        {
            label: 'OneClass',
            link: 'https://one.astronmembers.com/'
        },
        {
            label: 'Ocorrencias/OS',
            link: `${window.location.origin.replace(':3003', '')}/ocorrencias`
        },
        {
            label: 'Relatórios',
            navigate: '/relatorios'
            // labelNew: true
        },
        {
            label: 'Fechar eventos em massa',
            func: handleFecharEventosEmMassa
            // labelNew: true
        }
    ]

    const [confirmLogout, setConfirmLogout] = useState(false)

    const handleClickLinks = (event) => {
        setAnchorMenu(event.currentTarget)
    }

    const handleClickUser = (event) => {
        setUserMenu(event.currentTarget)
    }

    const handleCloseLinks = () => {
        setAnchorMenu(null)
    }

    const handleCloseUser = () => {
        setUserMenu(null)
    }

    const handleLogout = () => {
        setUserMenu(false)
        setConfirmLogout(false)
        logout()
        Navigate('/login')
    }

    const [onboardingOk, setOnboardingOk] = useState(logado && !user.onboardingOk)

    useEffect(() => {
        if (logado && !user.onboardingOk) {
            setOnboardingOk(true)
        }
    }, [logado])

    const styleVersoes = {
        fontWeight: "bold",
        fontSize: "0.9rem",
        color: "text.secondary"
    }

    const sxTypografy = {
        color: 'black',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        overflowWrap: 'break-word'
    }

    const ItemMenuAdmin = ({ index, item, labelNew }) => {
        return (
            <MenuItem key={index} sx={active_page === item.navigate ? { background: '#dedede', fontWeight: 700 } : {}}
                onClick={() => {
                    if (item.navigate) { Navigate(item.navigate) }
                    if (item.func && typeof item.func == "function") { item.func() }
                    setAnchorMenu(false)
                }} >
                { (item.navigate || item.funcao) ? (<Label item={item} labelNew={labelNew} />) : <a style={{ textDecoration: 'none', color: 'black' }} target="_blank" href={item.link} rel="noreferrer"> <Label item={item} labelNew={labelNew} /> </a>}
            </MenuItem>
        )
    }

    const ItemMenuOperador = ({ index, item, labelNew }) => {
        return (
            <MenuItem key={index} sx={active_page === item.navigate ? { background: '#dedede', fontWeight: 700 } : {}}
                onClick={() => {
                    if (item.navigate) { Navigate(item.navigate) }
                    if (item.func && typeof item.func == "function") { item.func() }
                    setAnchorMenu(false)
                }} >
                {item.navigate ? (<Label item={item} labelNew={labelNew} />) : <a style={{ textDecoration: 'none', color: 'black' }} target="_blank" href={item.link} rel="noreferrer"> <Label item={item} labelNew={labelNew}/> </a>}
            </MenuItem>
        )
    }

    const Label = ({ item, labelNew }) => {
        return (
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', gap: '15px' }}>
                <span style={{ color: 'black' }}>{item.label}</span>

                {labelNew &&
                    <NewLabel label='Novo !' fontSize='14px' color='red' />
                }
            </Box>
        )
    }

    const permissaoFecharEventosEmMassa = (permissoes) => {
        if (!permissoes) { return false }

        let flag = false
        Object.values(permissoes).forEach((perm) => {
            if (perm.descricao == 'Plus') {
                Object.values(perm.itens).forEach((item) => {
                    if (item[0] == 'Pode fechar eventos em massa') {
                        flag = item[1] == 1
                    }
                })
            }
        })

        return flag
    }

    const [anchorEl, setAnchorEl] = useState(null)

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const [filaRelatorio, setGetFilaRelatorios] = useState([])
    const [anchorElDownloads, setAnchorElDownloads] = useState(null)
    const isOpenDownloads = Boolean(anchorElDownloads)

    const handleOpenDownloads = (event) => {
        setAnchorElDownloads(event.currentTarget)
        getFilaRelatorios()
    }

    const handleCloseDownloads = () => {
        setAnchorElDownloads(null)
    }

    const getFilaRelatorios = () => {
        sendWs('getFilaRelatorios', { conf: { userId: user.id, tipo: "MO" } })
    }

    const handleGetFilaRelatorios = (msg) => {
        if (msg.data) {
            setGetFilaRelatorios(msg.data)
        }
    }

    addRoute('getFilaRelatorios', handleGetFilaRelatorios)

    const handleCancelarRel = (msg) => {
        setAnchorElDownloads(null)
        if (filaRelatorio.rels && filaRelatorio.rels.em_processamento.length > 0) {
            CancelarRel(filaRelatorio.rels.em_processamento[0].SQLCancel)
        } else {
            console.error("código do relatório nao encontrado")
        }
    }

    const CancelarRel = (sqlCancelId) => {
        sendWs('CancelarRel', { id: sqlCancelId })
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const isOpen = Boolean(anchorEl)

    return (
        <Box sx={{ flexGrow: 1, display: (active_page == '/login' ? 'none' : 'flex') }}>
            {confirmLogout &&
                <ConfirmModal
                    titleText="Fazer logout"
                    open={confirmLogout}
                    text="Você deseja fazer logout?"
                    setOpen={setConfirmLogout}
                    cancelFunction={() => setConfirmLogout(false)}
                    confirmFunction={handleLogout}
                />
            }
            {onboardingOk &&
                <VideoApresentacao
                    key="video-apresentacao"
                    open={onboardingOk}
                    setOpen={setOnboardingOk}
                    idUser={user.id}
                />
            }
            <AppBar position="static" sx={{ background: theme.palette.one_bar_gradient, minHeight: '32px', height: '32px' }}>
                <Toolbar variant="dense" sx={BarHeight} disableGutters={true}>

                    <Box sx={BoxEsquerda} >
                        <img src={`${window.location.origin.replace(':3003', '')}/wsOnePortaria/images/logo_revenda.png` || Logo} onError={e => { e.target.src = Logo }} style={{ width: 'auto', height: '28px', alignSelf: 'center' }}/>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ cursor: 'pointer', ml: 1, mr: 0.5 }}
                            onClick={handleClickLinks}
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Tooltip title='Home' placement="bottom" arrow>
                            <IconButton
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="home"
                                sx={IconBtn}
                                onClick={() => { Navigate('/') }}
                            >
                                <Home />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='Livro Ata' placement="bottom" arrow>
                            <IconButton
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="Livro Ata"
                                sx={IconBtn}
                                onClick={() => {
                                    rmActiveCond(true)
                                    removerEventoSelecionado()
                                    changeShowComponent('livroAta')
                                    setTimeout(() => {
                                        document.getElementById('livroAtaGetDados').click()
                                    }, 10)
                                }}
                            >
                                <ReceiptLong />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='O.S' placement="bottom" arrow>
                            <IconButton
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="Ordem de serviço"
                                sx={IconBtn}
                                onClick={() => { rmActiveCond(true); removerEventoSelecionado(); buscarOrdensServico('all'); changeShowComponent('ordemServico') } }
                            >
                                <Build />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title='Downloads disponíveis' placement="bottom" arrow>
                            <IconButton
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="Downloads disponíveis"
                                sx={IconBtn}
                                ref={anchorElDownloads}
                                onClick={handleOpenDownloads}
                            >
                                <Download />
                            </IconButton>
                        </Tooltip>
                        <Popover
                            sx={{ marginTop: 0.5 }}
                            open={isOpenDownloads}
                            anchorEl={anchorElDownloads}
                            onClose={handleCloseDownloads}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left'
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left'
                            }}
                        >
                            <Box sx={{ padding: 2, minWidth: 200 }}>
                                <Typography sx={{ fontWeight: "bold", display: "flex", justifyContent: "center" }}>
                                            Downloads
                                </Typography>
                                <Divider sx={{ marginY: 0.5 }} />
                                {filaRelatorio && filaRelatorio.rels && (
                                    <Box>
                                        <Typography sx={sxTypografy}>
                                            {filaRelatorio.rels.em_processamento.map((em_andamento, index) => (
                                                <Typography key={index} sx={sxTypografy}>Relatório <span style={styleVersoes}>{em_andamento.nome}: </span><span style={{ color: em_andamento.status === 'aguardando' ? 'orange' : 'blue' }}> {em_andamento.status === 'aguardando' ? 'Aguardando' : em_andamento.status === 'processando' ? 'Processando' : ''}
                                                </span>
                                                <Button sx={{ marginLeft: 1 }} size="small" variant="outlined" onClick={handleCancelarRel}>Cancelar</Button>
                                                </Typography>
                                            ))}
                                        </Typography>
                                        {filaRelatorio.rels.finalizados.map((finalizados, index) => (
                                            <Typography key={index} sx={sxTypografy}>Relatório <span style={styleVersoes}>{finalizados.nome}: </span><span style={{ color: finalizados.status === 'cancelado' ? 'red' : 'green' }}>{finalizados.status === 'finalizado' ? 'Baixado' : finalizados.status === 'cancelado' ? 'Cancelado' : ''}</span></Typography>
                                        ))}
                                    </Box>
                                )}
                            </Box>
                        </Popover>
                        <Box />
                        <Menu
                            anchorEl={anchorMenu}
                            open={openMenu}
                            onClose={handleCloseLinks}
                        >
                            {menu_items.length > 0 &&
                                menu_items.map((item, i) => {
                                    if ((item.navigate && (item.navigate == "/gestaoEventos" || item.navigate == "/configuracoes")) || item.label == 'Fechar eventos em massa') {
                                        if ((item.label == 'Fechar eventos em massa' && permissaoFecharEventosEmMassa(user.permissoes)) || (item.label != 'Fechar eventos em massa' && user.nivel < 3)) {
                                            return <ItemMenuOperador key={`menu-operador-${i}`} index={i} item={item} labelNew={item.labelNew}/>
                                        }
                                        return null
                                    } else {
                                        return (
                                            <Box key={`menu-admin-${i}`}>
                                                <ItemMenuAdmin index={i} item={item} labelNew={item.labelNew}/>
                                            </Box>
                                        )
                                    }
                                })
                            }
                        </Menu>
                    </Box>
                    {openFecharEventos &&
                        <ModalFecharEventos open={openFecharEventos} setOpen={setOpenFecharEventos} />
                    }
                    <Box sx={BoxDireita} >
                        <Box>
                            <OneContador />
                        </Box>
                        <OneModal
                            maxWidth={"sm"}
                            open={openJornada}
                            setOpen={setOpenJornada}
                            titleText="Jornada"
                            FooterButtons={JornadaButton}>
                            <FormJornada setOpen={setOpenJornada}/>
                        </OneModal>
                        <Box sx={{ display: 'flex', alignItems: 'center', padding: '0 15px' }}>
                            <Tooltip title={'Jornada de trabalho'} placement="bottom" arrow>
                                <Button onClick={() => setOpenJornada(true)} startIcon={<HeadsetMic />} variant='contained' size='small' color='success' sx={{ height: 25, textTransform: 'none' }} >Jornada</Button>
                            </Tooltip>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                // border: '1.5px solid #bdbbbb',
                                // borderRadius: '5px',
                                cursor: 'pointer',
                                padding: '0 5px'
                            }}
                        >
                            {user &&
                                <Box
                                    onClick={handleClickUser}
                                    component='div'
                                    sx={BoxName}
                                >
                                    <AvatarOne margin="0 5px" height='25px' width="auto" src={`${window.location.origin.replace(':3003', '')}/wsOnePortaria/images/imgUsuarios/${user.img_perfil}` || null} />
                                    <span style={{ alignSelf: 'center' }}>
                                        {user.nome}
                                    </span>
                                    {openUserMenu ? (<KeyboardArrowUp sx={{ fontSize: '21px', alignSelf: 'center' }}/>) : (<KeyboardArrowDown sx={{ fontSize: '21px', alignSelf: 'center' }}/>)}
                                </Box>
                            }
                            <Menu
                                anchorEl={userMenu}
                                open={openUserMenu}
                                onClose={handleCloseUser}
                            >
                                <MenuItem
                                    onClick={() => {
                                        setConfirmLogout(true)
                                        setUserMenu(false)
                                    }}

                                    sx={{ fontSize: '14px', height: '20px', right: 0 }}
                                >
                                    <PowerSettingsNew sx={{ marginRight: '5px', fontSize: '20px' }}/>
                                    Logout
                                </MenuItem>
                            </Menu>
                        </Box>

                        {
                            global.versoes &&
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                padding: '0 2px'
                            }}>

                                <Tooltip title="Versões dos Sistemas" placement="bottom" arrow>
                                    <img
                                        style={{
                                            height: '20px',
                                            width: '20px',
                                            marginLeft: '5px',
                                            cursor: 'pointer'
                                        }}
                                        src={InfoCondIcone}
                                        onClick={handleOpen}

                                    />
                                </Tooltip>

                                <Popover
                                    sx={{ marginTop: 0.5 }}
                                    open={isOpen}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center"
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "center"
                                    }}
                                >
                                    <Box sx={{ padding: '10px 15px', minWidth: 200 }}>
                                        <Box sx={{ fontWeight: "bold", display: "flex", justifyContent: "center", height: '10px', padding: 0, margin: 0 }}>
                                            Versões
                                        </Box>
                                        <Divider sx={{ margin: '15px 0 5px 0' }} />
                                        <Typography sx={sxTypografy}>WsOnePortaria: <span style={styleVersoes}>{global.versoes?.wsOnePortaria}</span></Typography>
                                        <Typography sx={sxTypografy}>Qrtoken: <span style={styleVersoes}>{global.versoes?.Qrtoken}</span></Typography>
                                        <Typography sx={sxTypografy}>Plus: <span style={styleVersoes}>{global.versoes?.Plus}</span></Typography>
                                        <Typography sx={sxTypografy}>B.I: <span style={styleVersoes}>{global.versoes?.BI}</span></Typography>
                                    </Box>
                                </Popover>
                            </Box>
                        }

                        <Box sx={{ display: 'flex', alignItems: 'center', padding: '0 20px 0 15px' }}>
                            <Tooltip title={`Conexão com o servidor: ${(wsConectado ? 'online' : 'offline')}`} placement="left" arrow><Wifi sx={{ color: (wsConectado ? theme.palette.on : theme.palette.off) }} /></Tooltip>
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default memo(NavBar)
